var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.99998V5.19998C16.0798 4.48981 16.0054 3.77079 15.782 3.09198C15.5903 2.71567 15.2843 2.40973 14.908 2.21798C14.2292 1.99458 13.5102 1.92022 12.8 1.99998H11.2C10.4898 1.92022 9.77082 1.99458 9.092 2.21798C8.71569 2.40973 8.40974 2.71567 8.218 3.09198C7.99459 3.7708 7.92024 4.48981 8 5.19998V5.99998M10 11.5V16.5M14 11.5V16.5M3 5.99998H21M19 5.99998V17.2C19.1197 18.2652 19.0081 19.3438 18.673 20.362C18.3854 20.9264 17.9265 21.3854 17.362 21.673C16.3438 22.0081 15.2653 22.1196 14.2 22H9.8C8.73475 22.1196 7.65622 22.0081 6.638 21.673C6.07354 21.3854 5.61462 20.9264 5.327 20.362C4.99188 19.3438 4.88034 18.2652 5 17.2V5.99998",
    stroke: "#66338F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete4);
export default __webpack_public_path__ + "static/media/delete-4.7134f7e285e919217070616f02087a06.svg";
export { ForwardRef as ReactComponent };